


export const setActiveId = (data) =>({
    type: 'SET_ACTIVE_ID',
      payload: data
 })
 
 export const getLowerFunnelSection = ()=>({
      type: 'GET_LOWER_FUNNEL_SECTIONS'
 })
 
 export const setCompletedSections = (data)=>({
      type: 'SET_COMPLETED_SECTION',
      payload:data
 })
 
 export const setEditSection = (data)=>({
      type: 'SET_EDIT_SECTION',
      payload:data
 })
 export const setShowSubSection = (data)=>({
      type:"LOWER_FUNNEL_SECTIONS",
      data
 })
 export const resetCheckoutNew = ()=>({
      type:"RESET_NEW_CHECKOUT_TO_INITIAL_STATE"
 })